import { FC, memo, useCallback } from 'react';

import { ProductCard } from 'components/product-card';
import { useMenuCalories } from 'hooks/menu/use-menu-calories';

import { IModifierMultiplier } from './types';

export interface IRadioCheckListOption {
  label?: string;
  labelSuffix?: string;
  value: string;
}

export interface IModifierListItemProps {
  aspectRatio?: number;
  badgeContent?: string;
  content: {
    name: string;
    image?: string;
  };
  selectedOption?: string;
  onListItemPress?: (value: IModifierMultiplier) => void;
  itemValue: IModifierMultiplier;
  options?: IRadioCheckListOption[];
  onOptionPress?: (itemValue: IModifierMultiplier, optionValue: string) => void;
  isSelected?: boolean;
}

export const ModifierListItem: FC<IModifierListItemProps> = memo(
  ({
    aspectRatio = 0.8,
    badgeContent,
    content,
    isSelected = false,
    selectedOption,
    options,
    onListItemPress,
    itemValue,
    onOptionPress: onOptionPressProp,
  }) => {
    const { formatCalories } = useMenuCalories();

    const calories = formatCalories(itemValue?.nutrition?.calories?.def ?? 0);
    const price = itemValue?.price;

    const onProductPress = useCallback(() => {
      onListItemPress?.(itemValue);
    }, [itemValue, onListItemPress]);

    const onOptionPress = useCallback(
      (value: any) => {
        onOptionPressProp?.(itemValue, value);
      },
      [onOptionPressProp, itemValue]
    );

    return (
      <ProductCard
        aspectRatio={aspectRatio}
        isSelected={isSelected}
        onProductPress={onProductPress}
        badgeContent={badgeContent}
        selectedOption={selectedOption}
        options={options}
        onOptionPress={onOptionPress}
        productProps={{
          name: content.name,
          image: content.image,
          calories,
          price,
        }}
        imgObjectFitContain
      />
    );
  }
);
